export default __webpack_public_path__ + "static/media/masterCard.b05c9d95.svg";